import Search, { SearchInitConfig, SearchClientConfig} from "../search";
import Utility from '../../classes/utility';
import PCSearchCustomRender from '../customRenders/pc-custom-render'
import SearchUtility from "../utilities/search-utility";
import { MenuItem } from "instantsearch.js/es/connectors/menu/connectMenu";
import { ViewFilterType } from "../search";
import { SearchEventHitsRendered, SearchEventTypes, SearchEventKeyUp, SearchEventNoResults } from "../utilities/search-events";

// Define FacetsRefinements interface for counting active filters
interface FacetsRefinements {
    [key: string]: string[];
}

interface PlaceholderAreaElements {
    placeholderTag: HTMLTitleElement;
    resultsContainer: HTMLElement;
}

class ProgramsAndCoursesSearch extends Search {
    resetSearch: boolean = false;
    
    constructor(clientConfig: SearchClientConfig, initConfig: SearchInitConfig) {
        super(clientConfig, initConfig);
    }

    init() {
        super.init();

        // custom search for updating filter number on mobile button
        this.customSearch = function(helper) {
            let mobileFiltersButton = document.getElementById("mobile-filters-btn");
            if (mobileFiltersButton) {
                var filtersActiveCount: number = Object.values(this.search.helper.state.disjunctiveFacetsRefinements as FacetsRefinements)
                .reduce((acc: number, curr: Array<string>) => {
                    return acc + curr.length;
                }, 0);

                // if 0 display filters if not display filters (count)
                if (filtersActiveCount > 0) {
                    mobileFiltersButton.innerHTML = `Filters (${filtersActiveCount})`;
                } else {
                    mobileFiltersButton.innerHTML = `Filters`;
                }
            }
        };
        
        // get query in URL - if set
        let query = Utility.getUrlParameter(this.initConfig.queryName);

        // trigger filters
        // this.onloadGetParameters();
        // this.lazyloading = true;
        // trigger search on page load query
        if (query) {
            this.search.helper.setQuery(query)
            this.search.helper.search();
        }
    }

    private onLoadSearch() {
        const searchBox = document.getElementById(this.initConfig.searchBoxId);
        if (searchBox) {
            this.init();
        }
    }

    private onLoadViewFilters() {
        // init view filters
        // search needs to be defined for the below to work
        const searchBox = document.getElementById(this.initConfig.searchBoxId);
        const DeliverylabelFn = function (item: MenuItem) {
            item.label = Utility.removeAfterHyphen(item.label);
            return item;
        };

        // Use the getAOILabel function from SearchUtility
        const AOILabelFn = (item: MenuItem): MenuItem => {
            item.label = SearchUtility.getAOILabel(item.label);
            return item;
        };
        
        const ConedLabelFn = function (item: MenuItem) {
            item.label = item.label.split("-").pop();
            return item;
        };

        this.addViewFilter({
            elementId: "filter-aoi",
            urlParam: "areaofinterest",
            modFn: AOILabelFn,
            filterType: ViewFilterType.RefinementList,
            cssClasses : {
                input: "form-check-input",
                item: "form-check"
            }
        });

        this.addViewFilter({
            elementId:"filter-international-students",
            urlParam: "international",
            filterType: ViewFilterType.RefinementList,
            cssClasses: {
                input: "form-check-input",
                item: "form-check"
            }
        });

        this.addViewFilter({
            elementId:"filter-credentials",
            urlParam: "credential",
            filterType: ViewFilterType.RefinementList,
            cssClasses: {
                input: "form-check-input",
                item: "form-check"
            }
        });

        this.addViewFilter({
            elementId:"filter-coned",
            urlParam: "continuingeducation",
            modFn: ConedLabelFn,
            filterType: ViewFilterType.RefinementList,
            cssClasses: {
                input: "form-check-input",
                item: "form-check"
            }
        });

        this.addViewFilter({
            elementId:"filter-newest",
            urlParam: "other",
            urlSpace: true,
            filterType: ViewFilterType.RefinementList,
            cssClasses: {
                input: "form-check-input",
                item: "form-check"
            }
        });
        
        
        this.addViewFilter({
            filterType: ViewFilterType.Clear,
            elementId: `${this.initConfig.searchBoxId}-clear-filters`
        });

        this.addViewFilter({
            filterType: ViewFilterType.SortBy,
            elementId: `${this.initConfig.searchBoxId}-sortby`
        });
    }

    // onloadGetParameters()
    // {
    //     let urlSearchParams = new URLSearchParams(window.location.search);
    //     // force select to update value on URL parms
    //     /*let selectElement = function (id: string, valueToSelect: string) {
    //         let element = document.getElementById(id) as HTMLSelectElement;
    //         if (element !== null) {
    //             element.value = valueToSelect;
    //             element.dispatchEvent(new Event('change'));
    //         }
    //     }*/
    //     const self = this;
    //     if(urlSearchParams != null)
    //     {
    //         // if(urlSearchParams.has("areaofinterest"))
    //         // {
    //         //     var areaOfInterest = urlSearchParams.get('areaofinterest');
    //         //     if(areaOfInterest !== null) {
    //         //         self.filterOptions("filter-aoi", areaOfInterest);
    //         //     }
    //         // }
    //         // if(urlSearchParams.has("credential"))
    //         // {
    //         //     var credential = urlSearchParams.get('credential');
    //         //     if(credential!== null){
    //         //         self.filterOptions("filter-credentials", credential);
    //         //     }
    //         // }
    //         // if(urlSearchParams.has("international"))
    //         // {
    //         //     var international = urlSearchParams.get('international');
    //         //     if(international!== null){
    //         //         self.filterOptions("filter-international-students", international);
    //         //     }
    //         // }
    //         // if(urlSearchParams.has("continuingeducation"))
    //         // {
    //         //     var continuingeducation = urlSearchParams.get('continuingeducation');
    //         //     if(continuingeducation!== null){
    //         //         self.filterOptions("filter-coned", continuingeducation);
    //         //     }
    //         // }
    //         //
    //         // if(urlSearchParams.has("other"))
    //         // {
    //         //     var other = urlSearchParams.get('other');
    //         //     if(other!== null){
    //         //         self.filterOptions("filter-newest", other);
    //         //     }
    //         // }
    //     }
    // }

    private onLoadViewUpdates() {
        // programs and courses navigation tabs
        const tabsContainer = document.querySelector('.pc-tabs-container');
        if(tabsContainer != null){
            let pcTabs: NodeListOf<Element> = tabsContainer.querySelectorAll('.pc-tabs-container .nav-link');
            pcTabs.forEach(tab => {
                tab.addEventListener('click', function() {
                    const activeTab: HTMLElement = tabsContainer.querySelector('.nav-link.active') as HTMLElement;
                    if(activeTab){
                        activeTab.classList.remove('active');
                    }
                    this.classList.toggle('active');
                })
            });
        }

        this.searchEvents.addListener(SearchEventTypes.HitsRendered, (eventData: SearchEventHitsRendered) => {
            // guard statement to deflect to no results
            if (eventData.count == 0) return;
            const pcResultCount = document.querySelector(".pc-result-search-count") as HTMLParagraphElement;
            if (pcResultCount) {
                pcResultCount.innerHTML = "Showing <strong>" + eventData.count + "</strong> results";
            }
        });
    }

    public viewAreas(headerTitleShow): PlaceholderAreaElements {
        const resultsContainer: HTMLElement = document.getElementById(this.initConfig.resultContainerId);
        const placeholderTag: HTMLTitleElement = document.querySelector(".pc-result-search-count");

        if (placeholderTag) {
            if (headerTitleShow) {
                placeholderTag.classList.remove("d-none");
            } else {
                placeholderTag.classList.add("d-none");
            }
        }
        return {
            placeholderTag: placeholderTag,
            resultsContainer: resultsContainer
        }
    }

    override onLoad(facets: Array<any>) {
        //this.onLoadFacets(facets);
        this.onLoadViewFilters();
        this.onLoadSearch();
        this.onLoadViewUpdates();
    }
}
export default ProgramsAndCoursesSearch;